import React from 'react';
import Check from '@mui/icons-material/Check';
import * as S from './QuickOptions.styled';
import { LogKey, logKeys } from '../Logs';
import { moveTmpPanel } from 'pages/Navigation/utils';

const QuickOptions = ({
  quickLinks,
  checked,
  buttonLabel,
  lightPrimaryButton,
} :
{
  quickLinks: Record<string, any>[],
  checked: string | string[],
  buttonLabel: string,
  /** /logs mobile — light blue Select Activity (Metrics keeps solid blue). */
  lightPrimaryButton?: boolean,
}) => {
  const isMetric = buttonLabel.toLowerCase().includes('metric');

  const isSelected = (name: string) => (
    isMetric ? checked === name : (checked as string[]).includes(name)
  );

  const QOptionsParts = () => (
    <>
      <S.Chips>
        {quickLinks.map((qL) => {
          const selected = isSelected(qL.name);
          const isKey = isMetric
            || ([...logKeys] as LogKey[]).includes(qL.name as LogKey)
            || qL.name === 'Show all';
          return (
            <S.ActivitySet
              key={`qL_${qL.name}`}
              type="button"
              $selected={selected}
              $isKey={isKey}
              aria-pressed={selected}
              onClick={() => {
                qL.func(checked);
              }}
            >
              <S.Select $checked={selected} aria-hidden>
                {selected ? <Check fontSize="inherit" /> : null}
              </S.Select>
              <S.ActivityName1>{qL.name}</S.ActivityName1>
            </S.ActivitySet>
          );
        })}
      </S.Chips>
      <S.OptionButton
        type="button"
        $light={lightPrimaryButton}
        onClick={() => {
          if (isMetric) {
            moveTmpPanel('tmp_panel1');
          } else {
            moveTmpPanel('tmp_panel0');
          }
        }}
      >
        {buttonLabel}
      </S.OptionButton>
    </>
  );

  return isMetric ? (
    <S.Container2>
      <QOptionsParts />
    </S.Container2>
  ) : (
    <S.Container>
      <QOptionsParts />
    </S.Container>
  );
};

export default QuickOptions;
